import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Homepage from "./components/Homepage";
import './amplifyConfig';
import { initGA, trackPageView } from './utils/analytics';

// Google Analytics tracking component
function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);
}

function AppContent() {
  usePageTracking();

  return (
    <Routes>
      <Route path="/" element={<Homepage />} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    // Only track real production traffic. One GA4 property; staging, preview, and
    // localhost send nothing, so QA/testing never pollutes production analytics.
    const host = window.location.hostname;
    const isProd = host === 'automationvita.com' || host === 'www.automationvita.com';
    const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
    if (isProd && GA_MEASUREMENT_ID) {
      initGA(GA_MEASUREMENT_ID);
    }
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

export default App;